<template>
<div class="landingMain">
    <div v-if="!isLoggedIn" class="row">
        <div class="col-md-4 infoActionSection">
            <div class="infoActionContainer">
            <img class="conf-img" src="../assets/img/logo.jpg" style="height:100px;" alt="AARP Logo" />
            <h1 class="display-4" style="font-size: 60px; font-weight: 600;margin:125px 0 0 0;">Program Analysis<br/>& Reporting</h1>
            <p class="lead" style="font-size: 20px; font-weight: 400;margin:30px 0 0 0;">
                Session Expired. Please Login to continue.
            </p>
            <button type="button" class="btn btn-warning btn-lg" style="margin:30px 0 0 0;background-color: #FBC743 !important;color:black !important;width:260px;font-weight:bold;border-radius:5px;"  @click="login">
                Login
            </button>
            </div>
        </div>
        <div :style="{ background: 'white url(' + require('@/assets/img/landingpage-bg-grey-slant.png') + ') no-repeat center', padding:'75px 0 0 415px' }" class="col-md-8">
            <div></div>
            <div class="landingImg">
                <img class="conf-img" src="../assets/img/landing-page-image.png" style="" alt="metric image" />
            </div>
        </div>
    </div>
    <div v-else>
        <p class="lead">Your session is currently active. Please continue...</p>
    </div>
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "AppHeader",
    computed: {
        ...mapGetters(['isLoggedIn','currentUserEmail','currentUserGroups']),
    },
    methods: {
        ...mapActions(['login'])
    }
}
</script>
<style>

.jumbotron {
    width: 100%;
    height: 100%;
   
}

.landingMain {
  width: 100%;
  height: calc(100vh - 26px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.landingMain > div.row {
  width: 100%;
}
.infoActionContainer {
  max-width: max-content;
  margin-left: auto;
}

.infoActionSection {
  margin: 0px;
  padding: 10px 0px 0px 0px;
}

.landingImg {
  margin-left: auto;
  max-width: fit-content;
}
</style>
